<template>
  <div class="graph">
    <h2 class="title">
      <img class="logo" src="@/assets/fightcamp-letter.svg" /> Community Score
    </h2>
    <div class="row">
      <div class="block">
        <div class="bigtitle-container">
          <h1 class="bigtitle"> {{countTween | numFormat}}</h1>
          <h2 class="subtitle"> PUNCH COUNT</h2>
        </div>
      </div>
      <div class="block">
        <div class="bar-container">
                <span class="bar-label"> Main </span>

          <div class="bar-widget">
            <div class="bar" :style="{width: goal}">
            </div>
            <h3 class="bartext"> 1,000,000</h3>
          </div>
        </div>
        <div class="bar-container">
          <span class="bar-label"> Bonus </span>

          <div class="bar-widget">
            <div class="bar" :style="{width: goal2}">
            </div>
            <div class="bargradiant">
              <span class="bargradiant-line"> 1.1M </span>
              <span class="bargradiant-line"> 1.2M</span>
              <span class="bargradiant-line"> 1.3M </span>
              <span class="bargradiant-line"> 1.4M</span>
              <span class="bargradiant-line" style="border:none;"> 1.5M</span>
            </div>
            <h3 class="bartext"> &nbsp;</h3>
            
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
  import VueMixinTween from 'vue-mixin-tween';

  export default {
    name: 'LiveDisplay',
    props: {
      count: Number
    },

    mixins: [
      // The only required argument is the name of the property to tween.
      // The default duration is 500 milliseconds.
      // The default timing function is TWEEN.Easing.Quadratic.Out
      // We're using a "custom" linear timing function here.
      VueMixinTween('count', 2000, (pos) => pos)
    ],

    data() {
      return {}
    },
    computed: {

      goal() {

        let percent = (this.countTween / 10000);
        if (percent > 100) {
          percent = 100;
        }
        return percent + "%"
      },

      goal2() {
        if (this.countTween < 1000000) {
          return "0%";
        }
        let percent = ((this.countTween - 1000000) / 5000);
        if (percent > 100) {
          percent = 100;
        }
        return percent + "%"
      },
    },
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .bigtitle-container {
    border-radius: 5px;
    background-color: rgba(0, 0, 0, 0.5);
    align-items: center;
    display: flex;
    flex-direction: column;
    justify-content: center;
    flex: 0 1 auto;
    padding: 10px;
    margin: 20px 10px;
    box-sizing: border-box;

  }

  .graph {
    width: 100%;
    max-width: 1000px;
    margin: 0px auto;
    display: flex;
    flex-direction: column;
  }

  .row {

    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    align-items: stretch;
  }

  .block {
    flex: 1 1 375px;
    display: flex;
    flex-direction: column;
    justify-content: center;

  }

  @media only screen and (min-width: 600px) {
    .graph {
      padding: 0px 40px;

    }
    .bigtitle-container {
      padding: 20px 40px;
    }

  }

  .bar-container {
    display: flex;
    flex-direction: row;
    align-items: center;

  }

  .bar-label {
    flex: 0 0 50px;
    text-align: left;
    margin-left: 10px;;
    font-family: 'ProximaNova-Bold', 'Avenir', Helvetica, Arial, sans-serif;
  }

  .bar-widget {
    flex: 1 1 auto;
    border-radius: 5px;
    background-color: rgba(0, 0, 0, 0.5);
    margin: 10px 10px;
    position: relative;

  }

  .bar {
    box-sizing: border-box;
    border-radius: 5px;
    background-color: #FF3C3C;
    width: 0%;
    z-index: 0;
    height: 100%;
    ;
    position: absolute;
  }


  .bargradiant {
    z-index: 0;
    height: 100%;
    width: 100%;
    position: absolute;
    border-radius: 5px;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;

  }

  .bargradiant-line {
    height: 60%;
    width: 20%;
    border-right: 1px solid white;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
        font-family: 'ProximaNova-Bold', 'Avenir', Helvetica, Arial, sans-serif;

  }

  .bartext {
    box-sizing: border-box;
    padding: 5px 10px;
    text-align: right;
    margin: 5px 20px;
    z-index: 10;
    position: relative;

  }

  @media only screen and (min-width: 700px) {
    .bartext {
      font-size: 30px;
    }
  }


  .bigtitle {
    font-size: 60px;

    /*font-size: 14vw;*/
    color: white;
    margin: 0px;
    text-align: right
  }


  .subtitle {
    margin: 10px 0px 0px;
    font-size: 24px;
  }

  .logo {
    height: 17px;
    ;
  }

  .title {
    font-size: 22px;
    line-height: 1.2;
    margin: 30px 0px 0px;
  }
    @media only screen and (min-width: 600px) {
    .title {
    margin: 20px 0px ;
    }
  }
</style>